import { TextMessagingVerificationStatus } from "@redotech/redo-model/phone/phone-number";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const updatePhoneNumber = {
  name: "updatePhoneNumber" as const,
  input: z.object({
    id: z.string(),
    number: z.string(),
    verificationStatus: createEnum(TextMessagingVerificationStatus),
  }),
  output: z.null(),
};
